export default __webpack_public_path__ + "static/media/features-nft.e185bf1e.png";